import { render, staticRenderFns } from "./ModalDetailsSales.vue?vue&type=template&id=60d53d65&scoped=true"
import script from "./ModalDetailsSales.vue?vue&type=script&lang=js"
export * from "./ModalDetailsSales.vue?vue&type=script&lang=js"
import style0 from "./ModalDetailsSales.vue?vue&type=style&index=0&id=60d53d65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d53d65",
  null
  
)

export default component.exports